const getSvgCircleLength = el => 2 * Math.PI * parseFloat(el.getAttribute('r'))

export default getSvgCircleLength
